import * as ko from "knockout";
import Bao from "./../services/bao-service";
// bao migrate - module not found: import "services/bao-template-engine";
function BaseReportCenterModule(serverModel) {
    var self = this;
    self.WebUrl = ko.observable();
    self.TemplateName = ko.observable();
    var subscriptions = [];
    subscriptions.push(self.WebUrl.subscribe(function () {
        self.LoadHtml();
    }));
    ko.map.fromJS(serverModel, self);
    self.Refresh = function () { };
}
BaseReportCenterModule.prototype.LoadHtml = function () {
    var self = this;
    return Bao.get(self.WebUrl(), function (result) {
        var templateName = "Module";
        Bao.Templates[templateName] = result;
        self.TemplateName(templateName);
    });
};
export default BaseReportCenterModule;